module.exports = __webpack_public_path__ + "img/txf.actor2.17c95497.png";